<template>
  <div id="app_signup">
    <v-layout wrap justify-space-around>
      <v-flex xs12 md12 pa-8>
        <v-card id="app_height" outlined tile>
          <signupMain v-bind:signupData="signupdata" v-if="winStep == 0" @stepper="winStepper" />
          <signupVerify v-bind:signupData="signupdata" v-if="winStep == 1" @stepper="winStepper" />
          <signupSuccess v-bind:signupData="signupdata" v-if="winStep == 2" />
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import signupMain from "./../Signup/signupMain";
import signupVerify from "./../Signup/signupVerify";
import signupSuccess from "./../Signup/signupSuccess";

export default {
  components: {
    signupMain,
    signupVerify,
    signupSuccess
  },
  data() {
    return {
      winStep: 0,
      signupdata: {}
    };
  },
  methods: {
    winStepper(window_data) {
      this.winStep = window_data.winStep;
      this.signupdata.userId = window_data.userId;
      this.signupdata.authcode = window_data.authcode;
      this.signupdata.userType = window_data.userType;
      this.signupdata.userName = window_data.userName;
      this.signupdata.countryCode = window_data.countryCode;
      this.signupdata.phoneNo = window_data.phoneNo;
      this.signupdata.mailId = window_data.mailId;
      this.signupdata.password = window_data.password;
      this.signupdata.confPassword = window_data.confPassword;
      this.signupdata.inptDisable = window_data.inptDisable;
    }
  }
};
</script>
<style scoped>
#app_signup {
  background-image: url("../../assets/home_header.png");
  background-repeat: no-repeat;
  background-size: cover;
  color: white;
}
@media only screen and (min-width: 800px) {
  #app_height {
    min-height: 80vh;
  }
}
</style>